import { PlusIcon } from '@heroicons/react/16/solid'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import SampleBadge from '../../../../components/sample-data/sample-badge'
import Button from '../../../../components/tailwind/Button'
import { Heading } from '../../../../components/ui/Heading'
import { TalentBadge } from '../talent'

/**
 * Molecule Component: TalentComboboxOption
 * Displays a talent option in the combobox with add button
 */
const TalentComboboxOption = ({
  career,
  onAdd,
  focus = false,
  isDemo = false
}) => {
  return (
    <div
      className={clsx(
        'flex items-center justify-between px-4 py-3',
        focus ? 'bg-gray-50' : ''
      )}
    >
      <div className='flex items-center space-x-3'>
        <TalentBadge name={career.title || career.id} />
        <div>
          <div className='flex items-center space-x-1'>
            <Heading level={5}>{career.title || career.id}</Heading>
            {isDemo && <SampleBadge kind='career' />}
          </div>
          <div className='text-sm text-gray-500'>{career.id}</div>
        </div>
      </div>
      <div className='flex items-center space-x-2'>
        <div onClick={(e) => e.stopPropagation()}>
          <Button.SecondaryLG
            text='Hinzufügen'
            icon={<PlusIcon className='size-4 text-buttonSecondaryBlue' />}
            onClick={() => onAdd(career)}
          />
        </div>
      </div>
    </div>
  )
}

TalentComboboxOption.propTypes = {
  talent: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  }).isRequired,
  onAdd: PropTypes.func.isRequired,
  focus: PropTypes.bool
}

export default TalentComboboxOption
